import { BetaSignupForm } from '../components/BetaSignupForm';
import { useDocumentTitle } from '../lib/useDocumentTitle';

// The beta waitlist (TOM-634, ADR 0384). The public Sign up buttons lead here:
// a visitor leaves an email and POST /v1/beta-signup stores it. The form is
// shared with the home page (components/BetaSignupForm.tsx, TOM-980). /signup
// still works by its address, for boat activation, return-to-boat and invite
// links.
export function BetaSignup() {
  useDocumentTitle('Join the beta - Neomaris');

  return (
    <>
      <section className="page-hero">
        <h1 className="reveal">Join the Neomaris beta</h1>
        <p className="reveal reveal-delay-1">
          Neomaris is in a closed beta. Leave your email and we&apos;ll write when there is a place
          for you.
        </p>
      </section>

      <section className="section section--tight-top">
        <div className="section-inner">
          <div className="contact-form reveal" style={{ maxWidth: 480, margin: '0 auto' }}>
            <BetaSignupForm variant="page" inputId="id_beta_email" submitLabel="Join the beta" />
          </div>
        </div>
      </section>
    </>
  );
}
